module.exports = __webpack_public_path__ + "static/media/icon_doctor_avatar.c135b716.png";